const MenuPage = (($) => {
  let _els = {};
  // let _currentService = window.MapClientTimeToService.getCurrentService();

  const init = () => {
    _els.navBtns = $('.menu-nav--primary .btn');
    _els.menuContainer = $('.menu-container');
    _els.menus = $('.menu');

    _els.navBtns.on('click', (e) => {
      e.preventDefault();

      let $this = $(e.target);
      let targetMenu = $this.attr('data-target');

      _els.navBtns.removeClass('active');
      _els.menus.removeClass('active');
      _els.menus.filter('.' + targetMenu).addClass('active');

      $this.addClass('active');
    });

    // let $targetBtn = _els.navBtns.filter('[data-target*=' + _currentService + ']');
    // let $targetMenu = _els.menus.filter('.menu--' + _currentService);

    // if ($targetMenu.length == 0) {
    //   // default to dinner
    //   _els.navBtns.filter('[data-target*=' + 'dinner' + ']').addClass('active');
    //   _els.menus.filter('.menu--' + 'dinner').addClass('active');
    // } else {
    //   $targetBtn.addClass('active');
    //   $targetMenu.addClass('active');
    // }
  };

  module.exports = {
    init: init,
  };
})(jQuery);
